const buttonId = 'exportTableButton'

export function activateActions (gridApi) {
  const buttonElement = document.getElementById(buttonId)
  activateExport(buttonElement, gridApi)
}

function activateExport (buttonElement, gridApi) {
  // console.log('activateExport', element)
  buttonElement?.addEventListener('click', function () {
    if (!gridApi.exportDataAsCsv) return

    gridApi.exportDataAsCsv({
      skipPinnedTop: true
    })
  })
}
